import React, { useState, useEffect } from 'react';
import './home.css'
import play from '../../assets/play.png';
import Spinner from 'react-spinner-material';

import * as firebase from 'firebase';
import settings from '../../settings'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import ResultText from '../Result/ResultText';

var provider = new firebase.auth.FacebookAuthProvider();
provider.addScope('public_profile');
provider.addScope('email');
provider.addScope('user_friends');

export default function Login({ history }) {

    const [name, setName] = useState(localStorage.getItem("name"));
    const [email, setEmail] = useState(localStorage.getItem("email"));
    const [userId, setUserId] = useState(localStorage.getItem("userId"));
    const [userPicture, setUserPicture] = useState(localStorage.getItem("userPicture") || '');
    const [resultFinish, setResultFinish] = useState(localStorage.getItem("feito"));
    const [openDialog, setOpenDialog] = useState(false);
    const [openToast, setOpenToast] = useState(false);
    const [runLoad, setRunLoad] = useState(false);
    const [facebookLogin, setFacebookLogin] = useState(false);


    useEffect(() => {
        if (localStorage.getItem("userId") != '' && localStorage.getItem("userId") !== undefined && localStorage.getItem("userId") !== null) {
            setFacebookLogin(true)
            getUserData()
            if (localStorage.getItem("testDone") != '' && localStorage.getItem("testDone") !== undefined && localStorage.getItem("usetestDonerId") !== null) {
                if (localStorage.getItem("testDone")) {
                    writeResultUser()
                }
            }
            checkIfUserHasSavedAnswers()
        } else {
            console.log('User is not logged in')
        }
        setRunLoad(false);
    }, [userId])

    function checkIfUserHasSavedAnswers(){
        firebase.database().ref('saved-answers/' + localStorage.getItem("userId")).once('value').then(function (snapshot) {
            console.log("checkIfUserHasSavedAnswers")
            const savedAnswers = (snapshot.val() && snapshot.val().questionsValue) || [];
            console.log(savedAnswers)
            const getSavedLocal = JSON.parse(localStorage.getItem("savedAnswers"))
            if(savedAnswers && getSavedLocal){
                if(savedAnswers.length > getSavedLocal.length){
                    localStorage.setItem("savedAnswers", JSON.stringify(savedAnswers));
                }
            }
        })
    }

    function writeResultUser() {
        console.log("Saving user data!")
        const userLogged = {
            deviceId: localStorage.getItem("deviceId"),
            email: localStorage.getItem("email"),
            id: localStorage.getItem("userId"),
            imagemPerfil: localStorage.getItem("userPicture"),
            nome: localStorage.getItem("name"),
            qtComments: localStorage.getItem("qtComments"),
            qtLikes: localStorage.getItem("qtLikes"),
            whoLiked: JSON.parse(localStorage.getItem("whoLiked")),
            resultado: {
                feito: true,
                max: localStorage.getItem("numberResult"),
                perfil1: localStorage.getItem("perfil1"),
                perfil2: localStorage.getItem("perfil2"),
                perfil3: localStorage.getItem("perfil3"),
                perfil4: localStorage.getItem("perfil4"),
                perfil5: localStorage.getItem("perfil5"),
                perfil6: localStorage.getItem("perfil6"),
                perfil7: localStorage.getItem("perfil7"),
                perfil8: localStorage.getItem("perfil8"),
                perfil9: localStorage.getItem("perfil9"),
                resultadoPerfilNome: ResultText.type_names[localStorage.getItem("number"), - 1],
                resultadoPerfilNumero: localStorage.getItem("number"),
            }
        }
        console.log("User Logged")
        console.log(userLogged)
        localStorage.setItem('userLogged', JSON.stringify(userLogged));
        firebase.database().ref('usuarios/' + localStorage.getItem("userId")).set(userLogged);
    }

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    function goToQuestions() {
        history.push('/rules')
    }

    function goToTypes() {
        history.push('/types')
    }

    function goToEneagramaWhat() {
        history.push('/explanation')
    }

    function goToResult() {
        history.push('/result');
    }

    function goToAboutCaique() {
        history.push('/aboutCaique');
    }

    function getFriends() {
        if (facebookLogin) {
            window.FB.api(
                `/${localStorage.getItem("userId")}/friends?access_token=${localStorage.getItem("token")}`,
                'GET',
                {},
                function (response) {
                    console.log(response);
                }
            );
            history.push('/friendsList');
        }
        else {
            setOpenDialog(true)
        }
    }


    function handleCloseErrorInLogin() {
        setOpenToast(false)
    }

    function handleErrorInLogin() {
        setOpenToast(true)
    }

    function getUserData() {
        var numberResult = 0
        var number = 0
        var qtComments = 0
        var qtLikes = 0
        var deviceId = ''
        var whoLiked = []
        var feito = false
        var perfil1 = 0
        var perfil2 = 0
        var perfil3 = 0
        var perfil4 = 0
        var perfil5 = 0
        var perfil6 = 0
        var perfil7 = 0
        var perfil8 = 0
        var perfil9 = 0

        firebase.database().ref('/usuarios/' + userId).once('value').then(function (snapshot) {
            console.log("Getting user data!")
            qtComments = (snapshot.val() && snapshot.val().qtComments) || 0;
            qtLikes = (snapshot.val() && snapshot.val().qtLikes) || 0;
            deviceId = (snapshot.val() && snapshot.val().deviceId) || '';
            whoLiked = (snapshot.val() && snapshot.val().whoLiked) || [];
            number = (snapshot.val() && snapshot.val().resultado.resultadoPerfilNumero) || 0;
            numberResult = (snapshot.val() && snapshot.val().resultado.max) || 0;
            feito = (snapshot.val() && snapshot.val().resultado.feito) || false;
            perfil1 = (snapshot.val() && snapshot.val().resultado.perfil1) || 0;
            perfil2 = (snapshot.val() && snapshot.val().resultado.perfil2) || 0;
            perfil3 = (snapshot.val() && snapshot.val().resultado.perfil3) || 0;
            perfil4 = (snapshot.val() && snapshot.val().resultado.perfil4) || 0;
            perfil5 = (snapshot.val() && snapshot.val().resultado.perfil5) || 0;
            perfil6 = (snapshot.val() && snapshot.val().resultado.perfil6) || 0;
            perfil7 = (snapshot.val() && snapshot.val().resultado.perfil7) || 0;
            perfil8 = (snapshot.val() && snapshot.val().resultado.perfil8) || 0;
            perfil9 = (snapshot.val() && snapshot.val().resultado.perfil9) || 0;

            localStorage.setItem("numberResult", numberResult);
            localStorage.setItem("number", number);
            localStorage.setItem("typeAndName", ResultText.type_and_name[number - 1]);
            localStorage.setItem("qtComments", qtComments);
            localStorage.setItem("whoLiked", JSON.stringify(whoLiked));
            localStorage.setItem("qtLikes", qtLikes);
            localStorage.setItem("perfil1", perfil1);
            localStorage.setItem("perfil2", perfil2);
            localStorage.setItem("perfil3", perfil3);
            localStorage.setItem("perfil4", perfil4);
            localStorage.setItem("perfil5", perfil5);
            localStorage.setItem("perfil6", perfil6);
            localStorage.setItem("perfil7", perfil7);
            localStorage.setItem("perfil8", perfil8);
            localStorage.setItem("perfil9", perfil9);
            localStorage.setItem("feito", feito);
            localStorage.setItem("deviceId", deviceId);
        
            const userLogged = {
                deviceId: deviceId,
                email: localStorage.getItem("email"),
                id: localStorage.getItem("userId"),
                imagemPerfil: localStorage.getItem("userPicture"),
                nome: localStorage.getItem("name"),
                qtComments: qtComments,
                qtLikes: qtLikes,
                whoLiked: whoLiked,
                resultado: {
                    feito: feito,
                    max: numberResult,
                    perfil1: perfil1,
                    perfil2: perfil2,
                    perfil3: perfil3,
                    perfil4: perfil4,
                    perfil5: perfil5,
                    perfil6: perfil6,
                    perfil7: perfil7,
                    perfil8: perfil8,
                    perfil9: perfil9,
                    resultadoPerfilNome: ResultText.type_names[number - 1],
                    resultadoPerfilNumero: number
                }
            }
            console.log("Home")
            console.log("User Logged")
            console.log(userLogged)
            localStorage.setItem('userLogged', JSON.stringify(userLogged));
            setName(localStorage.getItem("name"))
            setResultFinish(localStorage.getItem("feito"))
        })
    }

    function handleLoginFacebook() {
        setRunLoad(true);
        setOpenDialog(false);
        firebase.auth().signInWithPopup(provider)
            .then(function (result) {
                var token = result.credential.accessToken;
                console.log(result);
                fetch(`https://graph.facebook.com/me?access_token=${token}`)
                    .then(function (response) {
                        try {
                            if (response.ok) {
                                return response.json();
                            } else {
                                throw new Error("HTTP status " + response.status);
                            }
                        } catch (error) {
                            console.log('Error getting response id user');
                            return response.json();
                        }
                    })
                    .then(response => {
                        console.log(response)
                        var userPictureInternal = ''
                        try {
                            setUserPicture(`https://graph.facebook.com/${response.id}/picture?type=large`)
                            userPictureInternal = `https://graph.facebook.com/${response.id}/picture?type=large`
                            console.log(`https://graph.facebook.com/me?access_token=${token}`)
                        } catch (error) {
                            console.log('Error getting user image')
                            setUserPicture('')
                        }
                        localStorage.setItem("name", response.name);
                        localStorage.setItem("userId", response.id);
                        localStorage.setItem("userPicture", userPictureInternal);
                        localStorage.setItem("email", result.user.email);
                        localStorage.setItem("token", token);
                        localStorage.setItem("facebookLogin", true);
                        setFacebookLogin(true)
                        setEmail(result.user.email)
                        setName(response.name);
                        setUserId(response.id);
                        console.log("Seted user id")
                    });
            }).catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;
                var email = error.email;
                var credential = error.credential;
                handleErrorInLogin()
                console.log("ERROR!")
                console.log(error)
                console.log(openToast)
                setRunLoad(false);
            });
    }

    return (
        <div>
            {!resultFinish && (<p className='title-page'>Descubra o seu perfil!</p>)}
            <p className='title-page'>{localStorage.getItem("typeAndName")}</p>
            <div className='name-photo-container'>
                {userPicture.length > 2 &&
                    (<span className='photo-container'>
                        <img className='photo' src={userPicture} alt="foto de perfil do usuário" />
                    </span>)
                }
                {userPicture.length > 2 &&
                    (<p className='user-name'>{name ? name : ''} </p>)
                }
            </div>
            <span className='spinner' id='load'>
                <Spinner size={60} spinnerColor={"#449AE2"} visible={runLoad} />
            </span>
            <button onClick={goToQuestions} className='home-card'>
                <p className='title-text-card'>COMEÇAR O TESTE</p>
            </button>
            {resultFinish && (
                <button onClick={goToResult} className='home-card'>
                    <p className='title-text-card'>VER RESULTADO</p>
                </button>)
            }
            {true && (<button onClick={getFriends} className='home-card'>
                <p className='title-text-card'>RESULTADO AMIGOS</p>
            </button>)}
            <button onClick={goToTypes} className='home-card'>
                <p className='title-text-card'>SAIBA MAIS SOBRE OS PERFIS</p>
            </button>
            <button onClick={goToEneagramaWhat} className='home-card'>
                <p className='title-text-card'>O QUE É O ENEAGRAMA?</p>
            </button>
            <button onClick={goToAboutCaique} className='home-card'>
                <p className='title-text-card'>SOBRE O DESENVOLVEDOR</p>
            </button>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Login com Facebook necessário!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Para ver o resultado dos seus amigos, curtir e comentar é necessário
                        fazer login com o Facebook
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleLoginFacebook} color="primary" autoFocus>
                        Entrar com o Facebook
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                key={'bottom,center'}
                open={openToast}
                autoHideDuration={4000}
                onClose={handleCloseErrorInLogin}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">Erro ao fazer login, tente novamente!</span>}
            />
        </div>
    );
}